<template>
  <div class="student-analysis">
    <!-- 成绩分布 -->
    <div class="score-chart chart-item">
      <div class="chart-header">
        <span class="chart-title">成绩分布</span>
        <div class="total-info">
          <span class="total-value">{{ analysisData.courses[0].classStats.averageScore }}</span>
          <span class="total-label">平均分</span>
        </div>
      </div>
      <div class="chart-container">
        <Echart :options="scoreOptions" height="100%" />
      </div>
    </div>

    <!-- 学习参与度 -->
    <div class="participation-chart chart-item">
      <div class="chart-header">
        <span class="chart-title">学习参与度</span>
        <div class="total-info">
          <span class="total-value">{{ participationRate }}%</span>
          <span class="total-label">参与率</span>
        </div>
      </div>
      <div class="chart-container">
        <Echart :options="participationOptions" height="100%" />
      </div>
    </div>

    <!-- 学习进度分析 -->
    <div class="progress-chart chart-item">
      <div class="chart-header">
        <span class="chart-title">学习进度分析</span>
        <div class="total-info">
          <span class="total-value">85%</span>
          <span class="total-label">整体进度</span>
        </div>
      </div>
      <div class="chart-container">
        <Echart :options="progressOptions" height="100%" />
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import analysisData from '@/mock/teacher/analysis.json'

export default {
  name: 'TeacherStudentAnalysis',
  components: {
    Echart
  },
  data() {
    const participationRate = (
      (analysisData.courses[0].learningAnalysis.participationLevel.high +
        analysisData.courses[0].learningAnalysis.participationLevel.medium) /
      analysisData.courses[0].classStats.totalStudents * 100
    ).toFixed(1);

    return {
      chartHeight: '28vh',
      analysisData,
      participationRate,
      // 成绩分布配置
      scoreOptions: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['40%', '50%'],
            data: [
              { 
                name: '优秀(90-100)', 
                value: analysisData.courses[0].classStats.scoreDistribution['90-100'],
                itemStyle: { color: '#37a2da' }
              },
              { 
                name: '良好(80-89)', 
                value: analysisData.courses[0].classStats.scoreDistribution['80-89'],
                itemStyle: { color: '#32c5e9' }
              },
              { 
                name: '中等(70-79)', 
                value: analysisData.courses[0].classStats.scoreDistribution['70-79'],
                itemStyle: { color: '#67e0e3' }
              },
              { 
                name: '及格(60-69)', 
                value: analysisData.courses[0].classStats.scoreDistribution['60-69'],
                itemStyle: { color: '#9fe6b8' }
              },
              { 
                name: '不及格(0-59)', 
                value: analysisData.courses[0].classStats.scoreDistribution['below60'],
                itemStyle: { color: '#ffdb5c' }
              }
            ],
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                formatter: '{b}: {c}人\n{d}%',
                color: '#fff'
              }
            }
          }
        ]
      },

      // 学习参与度配置
      participationOptions: {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '10%',
          right: '5%',
          bottom: '10%',
          left: '5%',
          containLabel: true
        },
        radar: {
          indicator: [
            { name: '课堂参与', max: 100 },
            { name: '作业完成', max: 100 },
            { name: '讨论互动', max: 100 },
            { name: '资源学习', max: 100 },
            { name: '测验参与', max: 100 }
          ],
          splitArea: {
            areaStyle: {
              color: ['rgba(255,255,255,0.02)', 'rgba(255,255,255,0.05)']
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          name: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [
                  analysisData.courses[0].learningAnalysis.classParticipation || 85,
                  (analysisData.courses[0].learningAnalysis.homeworkCompletion.onTime / 
                   analysisData.courses[0].classStats.totalStudents * 100),
                  analysisData.courses[0].learningAnalysis.discussionParticipation || 75,
                  analysisData.courses[0].learningAnalysis.resourceUtilization || 80,
                  analysisData.courses[0].learningAnalysis.quizParticipation || 85
                ],
                name: '参与度',
                lineStyle: {
                  color: '#37a2da',
                  width: 2
                },
                areaStyle: {
                  color: new this.$echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                    { offset: 0, color: 'rgba(55,162,218,0.5)' },
                    { offset: 1, color: 'rgba(55,162,218,0.1)' }
                  ])
                },
                symbolSize: 6,
                itemStyle: {
                  color: '#37a2da'
                }
              }
            ]
          }
        ]
      },

      // 学习进度分析配置
      progressOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['已完成', '进行中', '未开始'],
          textStyle: { color: '#fff' },
          top: 0
        },
        grid: {
          top: '15%',
          right: '5%',
          bottom: '12%',
          left: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          max: 100,
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: {
            color: '#fff',
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: { color: 'rgba(255,255,255,0.1)' }
          }
        },
        yAxis: {
          type: 'category',
          data: ['第一章', '第二章', '第三章', '第四章', '第五章'],
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        series: [
          {
            name: '已完成',
            type: 'bar',
            stack: 'total',
            data: [80, 85, 90, 70, 60],
            itemStyle: { color: '#67e0e3' }
          },
          {
            name: '进行中',
            type: 'bar',
            stack: 'total',
            data: [15, 10, 5, 20, 25],
            itemStyle: { color: '#37a2da' }
          },
          {
            name: '未开始',
            type: 'bar',
            stack: 'total',
            data: [5, 5, 5, 10, 15],
            itemStyle: { color: '#ffdb5c' }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.student-analysis {
  padding: 8px;
  height: 100%;
  display: grid;
  grid-template-rows: 30% 30% 40%;
  gap: 8px;

  .chart-item {
    background: rgba(6, 30, 93, 0.5);
    border-radius: 4px;
    padding: 8px;
    backdrop-filter: blur(4px);
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .chart-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 4px;
      flex-shrink: 0;
      height: 28px;

      .chart-title {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        &::before {
          content: '';
          display: inline-block;
          width: 3px;
          height: 14px;
          background: #9fe6b8;
          margin-right: 6px;
          vertical-align: middle;
          border-radius: 2px;
        }
      }

      .total-info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .total-value {
          font-size: 18px;
          color: #9fe6b8;
          font-weight: bold;
        }

        .total-label {
          font-size: 12px;
          color: #fff;
          opacity: 0.8;
        }
      }
    }

    .chart-container {
      flex: 1;
      min-height: 0;
      height: calc(100% - 32px);
      position: relative;

      :deep(.echarts) {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}
</style> 